import React from "react";
import Input from "../../../UI/Form/Input/Input";
import styled from "@emotion/styled";

const DynamicLimitContainer = styled.div`
  display: flex;
  width: ${(props) => props.width}%;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  color: ${(props) => props.theme.text.secondary};
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export default React.memo(function LimitRowsInput({
  limit,
  rowsQuantity,
  displayRows,
  sticky,
  width,
  setLimit,
}) {
  if (!displayRows || !rowsQuantity || sticky) {
    return null;
  }

  return (
    <DynamicLimitContainer width={width}>
      <Label>Display Rows:&nbsp;</Label>
      <Input value={limit} onChange={setLimit} type="number" />
      <Label>&nbsp;Total:&nbsp;{rowsQuantity}</Label>
    </DynamicLimitContainer>
  );
});
